import { Actions, createEffect, ofType } from "@ngrx/effects";
import { appActions } from "./actions";
import { map, switchMap } from "rxjs";
import { TestimonialsService } from "../services/testimonials.service";
import { Injectable } from "@angular/core";
import { BlogService } from "../services/blog.service";

@Injectable()
export class AppEffects {
    loadTestimonials$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(appActions.getTestimonials),
            switchMap(() => {
                return this.testimonialsService.getTestimonials().pipe(
                    map(testimonials => appActions.getTestimonialsSuccess({ testimonials }))
                );
            })
        );
    });

    loadBlogEntries$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(appActions.getBlogEntries),
            switchMap(() => {
                return this.blogService.getBlogEntries().pipe(
                    map(entries => appActions.getBlogEntriesSuccess({ entries: entries }))
                );
            })
        );
    });

    constructor(
        private actions$: Actions,
        private testimonialsService: TestimonialsService,
        private blogService: BlogService
    ) {}
}